var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('explore-frame',{attrs:{"partner_id":_vm.partner_id,"name":_vm.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }